import React from "react";
import classNames from "classnames";
import AddProductToWishlist from "theme/modules/Wishlist/AddProductToWishlist";
import AddWishlistProductToCart from "theme/modules/Wishlist/AddWishlistProductToCart";
import useKeepOpenedOnAction from "./useKeepOpenedOnAction";
import Form from "theme/components/atoms/Form/Form";
import AddProductToRequisitionList from "theme/modules/RequisitionList/AddProductToRequisitionList";

const ProductItemActions = ({
  product,
  wishlistItem,
  toggleProductInWishlistWhenAddedToCart,
  keepOpenedTimeout = 2000,
  addToCartOpenedDefault = false,
}) => {
  const { shouldKeepOpened, onAction, onDone } = useKeepOpenedOnAction({
    timeout: keepOpenedTimeout,
  });

  return (
    <div
      className={classNames("product-item-actions", {
        "product-item-actions--keep-opened": shouldKeepOpened,
      })}
    >
      <AddProductToWishlist
        {...wishlistItem}
        sku={product.sku}
        onAddStart={onAction}
        onAddDone={onDone}
      />

      {wishlistItem && (
        <AddWishlistProductToCart
          wishlistItem={wishlistItem}
          onAddStart={onAction}
          onAddDone={onDone}
          toggleProductInWishlistWhenAddedToCart={
            toggleProductInWishlistWhenAddedToCart
          }
          addToCartOpenedDefault={addToCartOpenedDefault}
        />
      )}
      {/* TEMPORARY: overrode this file to add a button to add product to requisition list. This is to be removed when extension points will be added */}
      <Form>
        <AddProductToRequisitionList
          idPrefix="category-page"
          product={product}
          selectedConfigurableOptions={[]}
          showOptionsModalIfNotFullyConfigured
        />
      </Form>
    </div>
  );
};

export default ProductItemActions;
